import BaseModel from './base-model';

export default class PropertyType extends BaseModel {
  constructor(opts = {}) {
    super(opts);

    this.name = opts['@COMMON_NAME'] ? opts['@COMMON_NAME'].trim() : null;
  }
}
